import { ChangeEvent, FunctionComponent, memo, useState } from 'react';
import './switch.scss';
import SwitchSmall from './switchSmall';

// /**
//  * Компонент Switch с возможностью добавления иконки внутри кружка
//  * @param {Object} props - Свойства компонента
//  * @param {boolean} props.defaultChecked - Начальное состояние переключателя
//  * @param {function} props.onChange - Функция обратного вызова при изменении состояния
//  * @param {React.ReactNode} props.icon - Иконка для отображения внутри кружка
//  * @param {string} props.className - Дополнительные классы CSS
//  */

export type SwitchProps = {
  defaultChecked?: any;
  onChange?: any;
  checked?: any;
  icon?: any;
  icon_direction?: any;
  className?: any;
  isDisabled?: boolean;
};

export const Switch: FunctionComponent<SwitchProps> = memo(
  ({
    defaultChecked = false,
    onChange,
    icon,
    className = '',
    isDisabled,
    checked: controlledChecked,
  }) => {
    const [internalChecked, setInternalChecked] = useState(defaultChecked);

    // Определяем, используется ли контролируемое состояние
    const isControlled = controlledChecked !== undefined;
    const checked = isControlled ? controlledChecked : internalChecked;

    // Определяем, какой тип иконки используется
    const isIconType = icon && icon.type && icon.type.name;
    const isSwitchIcon = isIconType === 'SwitchIcon';
    const isSwitchSec = isIconType === 'SwitchSec';
    const isSwitchClever = isIconType === 'SwitchClever';

    // Определяем классы для иконок
    const iconClassName = `switch_icon ${
      checked && isSwitchIcon ? 'switchIconActive' : ''
    } ${checked && isSwitchSec ? 'switchSecActive' : ''} ${
      !checked && isSwitchSec ? 'switchSecInactive' : ''
    } ${checked && isSwitchClever ? 'switchCleverActive' : ''} ${
      !checked && isSwitchClever ? 'switchCleverInactive' : ''
    }`;

    const handleChange = (e) => {
      const newChecked = e.target.checked;

      if (!isControlled) {
        setInternalChecked(newChecked);
      }

      if (onChange) {
        onChange(newChecked);
      }
    };

    return (
      <label className={`switch ${className}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          className="switch_input"
          disabled={isDisabled}
        />
        <span className="switch_slider">
          <span className="switch_thumb">
            {icon && <span className={iconClassName}>{icon}</span>}
          </span>
        </span>
      </label>
    );
  },
);

// Экспорт SwitchSmall для удобства
export { default as SwitchSmall } from './switchSmall';

// Компонент SwitchWithLabel - обертка над SwitchSmall с добавлением текста
export function SwitchWithLabel({ text, ...props }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{text}</span>
      {/* <SwitchSmall {...props} /> */}
    </div>
  );
}

export default Switch;
